import { Observable } from 'rxjs';
import { Fornitore, CreateFornitoreDto, UpdateFornitoreDto } from '../../models/fornitori.model';
import {AttoriQueryParams, AttoriPagedResponse, CreateAttoreDto} from '../../models/attori.model';

export abstract class FornitoriPort {
  abstract getList(): Observable<Fornitore[]>;
  abstract getListPaginated(params: AttoriQueryParams): Observable<AttoriPagedResponse<Fornitore>>;
  abstract getById(id: number): Observable<Fornitore>;
  abstract create(dto: CreateFornitoreDto): Observable<Fornitore>;
  abstract update(id: number, changes: UpdateFornitoreDto): Observable<Fornitore>;
  abstract delete(id: number): Observable<void>;
  abstract updateAttore(id: number, dto: Partial<CreateAttoreDto>): Observable<void>;
}
